import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";
import { IncidentControllerService } from "../../../services/incident-controller.service";
import { userAccess } from "../../../services/user-rights.service";
import { IncidentDTO } from "../../../models/incident";
import { MatDialog } from "@angular/material/dialog";
import { IncidentPopupComponent } from "../../pages/incident/incident-popup/incident-popup.component";
import { NgClass } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: "app-state-displayer-label",
  templateUrl: "./state-displayer-label.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./state-displayer-label.component.scss"],
  imports: [NgClass, MatProgressSpinner]
})
export class StateDisplayerLabelComponent {
  @Input() labelType: "incident" | "torn";
  @Input() deviceId: string;
  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();

  public incidentsLoading: boolean = false;

  constructor(
    private incidentService: IncidentControllerService,
    public dialog: MatDialog
  ) {}

  navigateToIncident(incident: IncidentDTO) {
    this.changeTab.emit({
      tab: userAccess.INCIDENT,
      incident: incident
    });
  }

  openIncidentsDialog(event) {
    event.stopPropagation();
    this.incidentsLoading = true;

    this.incidentService.getAllIncidentByDeviceId(this.deviceId).subscribe(
      (incidents) => {
        this.incidentsLoading = false;

        const dialogRef = this.dialog.open(IncidentPopupComponent, {
          maxWidth: "80vw",
          minHeight: "70vh",
          width: "80vw",
          height: "70vh",
          data: {
            incidents: incidents,
            deviceId: this.deviceId
          }
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.navigateToIncident(result);
          }
        });
      },
      (error) => {
        this.incidentsLoading = false;
        console.log("iIncidents loading failed", error);
      }
    );
  }
}
